module.exports = global["jQuery"] = require("-!/Users/mikemccarron/Sites/SVA/risolab.sva.edu/node_modules/expose-loader/index.js?$!./jquery.js");